import { api } from './api';

interface IUpdateClassesPeriod {
  year: number;
  quarter: number;
}

class UpdateClassesPeriodService {
  async getCurrent(): Promise<IUpdateClassesPeriod> {
    const response = await api.get<IUpdateClassesPeriod>(
      '/bs/update-classes-period',
    );

    return response.data;
  }
}

export default new UpdateClassesPeriodService();
